import icons from './icons.json'

export const howToClaim = [
	'Login to your account',
	'Report your claim, with details of the incident.',
	'Conduct post-loss inspection.',
	'Submit a repair estimate.',
	'Receive and accept your claim offer once your claim is approved.'
]
export const autoNeedToKnow = [
	'<strong>NIID and Validity:</strong>  Our auto insurance policies are licensed and genuine. Once the purchase is completed, the policy is automatically registered on NIID Database.',
	'<strong>Insurance Certificate:</strong>  Once purchased, the system automatically sends your insurance certificate via email to you. You can always present the certificate from your email to officials or print it as a hard copy format.'
]
export const autoHowToGetCovered = [
	'Submit all necessary information and documents.',
	'Activate your policy with your vehicle details.',
	'Conduct a pre-loss inspection to receive your insurance certificate.'
]
export const dialogLabelOption: BenefitStoreContext[string]['dialogLabels'] = {
	addToPlan: {
		title: 'Upload Vehicle Policy Holder',
		description: 'Select an option to upload your vehicle policy holders',
		options: {
			batch: { title: 'Batch Upload', description: 'Upload your vehicle policy holders via an Excel sheet' },
			manual: { title: 'Manual Upload', description: 'Enter your vehicle policy holders manually' }
		}
	},
	removeFromPlan: {
		title: 'Remove Vehicle From Plan',
		description: 'Select an option to remove a vehicle from your current plan',
		options: {
			batch: {
				title: 'Batch Removal',
				description: 'Upload the list of vehicles to remove via an Excel sheet.'
			},
			manual: {
				title: 'Manual Removal',
				description: 'Select the vehicles to remove'
			}
		}
	}
}

export const mini_comprehensive: BenefitStoreContext[string] = {
	short_description: 'Protects your vehicle against accidents and 3rd party damages for a one-time payment of ₦.',
	description:
		'Drive with confidence while you save on auto insurance costs with our unique mini comprehensive plan for ₦ only',
	product_title: 'Protect your vehicle against accidents and 3rd party damages',
	card_label: 'Protection against bodily injury, property damage, and third-party harm. Cost: mcg_price annually.',
	dialogLabels: dialogLabelOption,
	short_benefits: {
		'Need To Know': {
			icon: icons.need_to_know,
			isOpen: true,
			value: [
				'NIID and Validity: Our auto insurance policies are licensed and genuine. Once purchase and inspection is completed, the policy is automatically registered on NIID Database.',
				'Insurance Certificate: Once activated, your insurance certificate is automatically generated and sent to you via email. You can always present the certificate from your email to officials or print it in a hard copy format.'
			]
		},
		'How to get covered': {
			icon: icons.get_covered_icon,
			isOpen: false,
			value: [
				'Purchase a mini-comprehensive plan.',
				'Submit all necessary information and documents.',
				'Activate your policy with your vehicle details to receive your insurance certificate.',
				'Conduct a pre-loss inspection to be fully covered.'
			]
		},
		'Your Business Will Enjoy': {
			isOpen: false,
			icon: icons.business,
			value: [
				'Protection against damage to your vehicle due to accidents up to ₦500,000.',
				'Protection for third-party property damage up to ₦3,000,000.',
				'Unlimited coverage for third-party bodily injuries.'
			]
		}
	},
	allBenefits: {
		dialog: {
			benefits: [
				'Protection against damage to your vehicle due to accidents up to ₦500,000.',
				'Protection for third-party property damage up to ₦3,000,000.',
				'Unlimited coverage for third-party bodily injuries.'
			],
			need_to_know: [
				'NIID and Validity: Our auto insurance policies are licensed and genuine. Once purchase and inspection is completed, the policy is automatically registered on NIID Database.',
				'Insurance Certificate: Once activated, your insurance certificate is automatically generated and sent to you via email. You can always present the certificate from your email to officials or print it in a hard copy format.'
			],

			'How to claim': [
				'Login to your account and go to the claims section.',
				'Report your claim with details of the incident.',
				'Conduct post-loss inspection.',
				'Submit a repair estimate.',
				'Receive and accept your claim offer once your claim is approved.'
			]
		}
	}
}
